import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7bf4a7c9&scoped=true&lang=pug&"
import script from "./Sidebar.vue?vue&type=script&lang=ts&"
export * from "./Sidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf4a7c9",
  null
  
)

export default component.exports